import React from 'react';
import { StatusBadge } from '../components/ui';
import { FRIST_LAGE_TONE, fristText, type Fristen } from '../services/vertragService';

/** Frist eines Vertrags als Ampel-Badge ("kündigen bis …", "endet am …"); rot innerhalb des Erinnerungsvorlaufs. */
export const VertragFristBadge: React.FC<{ fristen: Fristen }> = ({ fristen }) => {
  const text = fristText(fristen);
  if (!text) return <span className="text-secondary">—</span>;
  return <StatusBadge tone={FRIST_LAGE_TONE[fristen.lage]}>{text}</StatusBadge>;
};

export default VertragFristBadge;
